import React, { lazy } from 'react';
import { useAppSelector } from '../../stores/redux.store';
import { useLoginPageViewed } from './hooks/useLoginPageViewed';
import { LoginTooManyAttemptsRecaptchaContextProvider } from './contexts/LoginTooManyAttemptsRecaptchaContext';
import { LoginRecoveryOptionsContextProvider } from './contexts/LoginRecoveryOptionsContext';
import { LoginGoogleOneTapRenderBoundary } from './components/LoginGoogleOneTap';
import { MarketingConsentContextProvider } from './contexts/LoginMarketingConsentContext';
import { useShouldOrchestrate } from '../orchestrator';

import OrchestratedLoginPage from './OrchestratedPage';
import { useSearchParamCodes } from './hooks/utility';
import { RecaptchaContextProvider } from '../../contexts/recaptcha';
import { loginPageId } from './constants';

const BasePage = lazy(() => import('./BasePage'));

const LoginPage = () => {
  useLoginPageViewed();
  const shouldOrchestrate = useShouldOrchestrate();

  const loginError = useAppSelector(state => state.login?.error);

  const { errorCode } = useSearchParamCodes();

  const error = loginError || errorCode;
  const recaptchaType = error?.code === 'captchaScoreTooLow' ? 'checkbox' : 'score';

  return (
    <LoginTooManyAttemptsRecaptchaContextProvider>
      <LoginRecoveryOptionsContextProvider>
        <LoginGoogleOneTapRenderBoundary>
          <MarketingConsentContextProvider>
            <RecaptchaContextProvider
              pageId={loginPageId}
              action="checkUsername"
              type={recaptchaType}>
              {shouldOrchestrate ? <OrchestratedLoginPage /> : <BasePage />}
            </RecaptchaContextProvider>
          </MarketingConsentContextProvider>
        </LoginGoogleOneTapRenderBoundary>
      </LoginRecoveryOptionsContextProvider>
    </LoginTooManyAttemptsRecaptchaContextProvider>
  );
};

export default LoginPage;
